<template>
  <div class="p-col-12 avail-search">
    <div class="p-grid">
      <div class="p-col-12">
        <span class="avail-number p-mr-2">{{ index }}</span>
        <DropDown v-model="type" :options="types" optionLabel="name" optionValue="type"></DropDown>
      </div>
      <template v-for="(item) of getTrafficLightSearchList(uniqueId)">
        <SearchRow v-bind:key="item.uniqueId" :fieldList="fieldList" :uniqueId="item.uniqueId"></SearchRow>
      </template>
      <div class="p-col-12" style="text-align: right">
        <Button :label="translate('button.add.condition')" class="search-row-button p-button-secondary"
                icon="pi pi-plus-circle" v-on:click="addSearchRowToTrafficLight(uniqueId)"></Button>
        <Button :label="translate('button.clone.trafficlight')" class="search-row-button p-button-secondary"
                icon="pi pi-copy" v-on:click="cloneTrafficLight(uniqueId)"></Button>
        <Button :label="translate('button.remove.trafficlight')" class="search-row-button p-button-secondary"
                icon="pi pi-trash" v-on:click="removeTrafficLight(uniqueId)"></Button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import SearchRow from "./SearchRow";
import TranslateService from "../services/translate.service";

export default {
  name: "SearchRowContainer",
  components: {SearchRow},
  props: {
    fieldList: Array,
    conditions: Object,
    uniqueId: Number,
    index: Number
  },
  data() {
    return {
      id: this.uniqueId,
      type: 'NEEDED',
      types: [
        {id: 1, name: 'Optional', type: 'OPTIONAL'},
        {id: 2, name: 'Needed', type: 'NEEDED'},
      ]
    }
  },
  methods: {
    ...mapActions('search', [
      'addSearchRowToTrafficLight',
      'cloneTrafficLight',
      'removeTrafficLight',
      'setTrafficLightType'
    ]),
    getType() {
      this.type = this.getTrafficLightType(this.uniqueId);
    },
    translate(message) {
      return TranslateService.translateMessage(message);
    }
  },
  computed: {
    ...mapGetters('search', [
      'getTrafficLightSearchList',
      'getTrafficLightType'
    ])
  },
  watch: {
    type() {
      let call = {uniqueId: this.uniqueId, type: this.type};
      this.setTrafficLightType(call);
    }
  },
  mounted() {
    this.getType();
  }
}
</script>

<style scoped>
.avail-search {
  margin-bottom: 5px;
  background-color: #f3f3f3;
}

.avail-number {
  background-color: #3667B2;
  color: white;
  border-radius: 10px;
  padding: 8px;
}

.p-button {
  margin-right: 5px;
}


</style>